export default __webpack_public_path__ + "static/media/component_play_shield_v1_top.3f6c95ff.png";